import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyDxC2NxzhU5bWBDdGy3TWV5oIz2cPpE4Is",
  // authDomain: "lockdownbootcamp.firebaseapp.com",
  // databaseURL: "https://lockdownbootcamp.firebaseio.com",
  projectId: "lockdownbootcamp-ba189"
  // storageBucket: "lockdownbootcamp.appspot.com",
  // messagingSenderId: "806617026098",
  // appId: "1:806617026098:web:a8bc7c82f45b645924762b",
  // measurementId: "G-BDMH0R6KV9"
};

// Get a Firestore instance
export const db = firebase.initializeApp(firebaseConfig).firestore();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore;
export { Timestamp, GeoPoint };

// if using Firebase JS SDK < 5.8.0
// db.settings({ timestampsInSnapshots: true })

export default {
  data() {
    return {
      hangouts: [],
      workouts: [],
      checkouts: [],
    };
  },

  firestore: {
    workouts: db.collection("workouts"),
    checkouts: db.collection("checkouts"),
    hangouts: db.collection("hangouts"),
  }
};
